module.exports = __webpack_public_path__ + "img/D202107_2.f9efd27d.jpg";